import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@/assets/scss/_custom-vuetify.scss";
import { createVuetify } from "vuetify";
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VCalendar } from "vuetify/lib/labs/components.mjs";
import { VTimePicker } from 'vuetify/labs/VTimePicker';

export default createVuetify({
  defaults: {
    VBtn: {
      elevation: 0,
      class: "text-none",
    },
    VCard: {
      class: "vuetify-card",
    },
    VAutocomplete: {
      VChip: {
        color: "primary",
        rounded: "lg",
        variant: "flat",
      },
    },
    VTable: {
      class: "table-component",
    },
    VRangeSlider: {
      class: "vuetify-range-slider",
    },
    VCol: {
      class: "vuetify-col"
    }
  },
  theme: {
    themes: {
      defaultTheme: {
        dark: false,
        colors: {
          background: "#f7f7f7",
          primary: "#226494",
          secondary: "#1e1a22",
          light: "#eef0f7",
          info: "#4ab0c1",
          danger: "#ff6c6c",
          success: "#2dcb73",
          warning: "#f6b749",
          "on-primary": "#FFFFFF",
          "on-secondary": "#FFFFFF",
          "on-info": "#FFFFFF",
          "on-success": "#FFFFFF",
          "on-warning": "#FFFFFF",
          "on-danger": "#FFFFFF",
        },
      },
    },
  },
  components: {
    VDateInput,
    VCalendar,
    VTimePicker
  },
  directives
});
